export default {
    namespaced: true,
    state: {
      selectedCampaignText: null
    },
    mutations: {
      setSelectedCampaignText(state, text) {
        state.selectedCampaignText = text
      }
    },
    actions: {
      updateSelectedCampaignText({ commit }, text) {
        commit('setSelectedCampaignText', text)
      }
    }
  }
  